(() => {
  const bind = (root) => {
    root.querySelectorAll('.shopify-section').forEach((section) => {
      const slider = section.querySelector('.swiper');
      if (!slider) return;
      const pairs = [['.arrow-left', -1], ['.arrow-right', 1], ['.arrow-left-button', -1], ['.arrow-right-button', 1], ['.feature-collection-left', -1], ['.feature-collection-right', 1]];
      pairs.forEach(([selector, direction]) => {
        section.querySelectorAll(selector).forEach((button) => {
          if (button.dataset.scrollBound) return;
          button.dataset.scrollBound = 'true';
          button.addEventListener('click', () => slider.scrollBy({left: direction * slider.clientWidth * 0.8, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'}));
        });
      });
    });
  };
  bind(document);
  document.addEventListener('shopify:section:load', () => bind(document));
})();
